import { FormattedMessage } from 'react-intl';

import Icon from '../../../components/Icon/Icon';
import Spinner from '../../../components/Spinner/Spinner';
import Tag from '../../../components/Tag/Tag';

import useNetworkTab from './useNetworkTab';

import { Props, TabStatus } from './NetworkTab.model';

import styles from './NetworkTab.module.scss';

const NetworkTab = (props: Props) => {

  const {
    onClickNetworkItem,
		state: {
			network,
			tabStatus,
		}
	} = useNetworkTab(props);

  return (
		<div className={styles.tabContent}>
			<Spinner spinning={tabStatus === TabStatus.Loading} />

			{network.map(item =>
				<div className={styles.card} key={item.userId}>
					<div className={styles.imageWrapper} onClick={onClickNetworkItem.bind(null, item.userId)}>
		
						{item.imageId ?
							<img alt="Profile" src={item.imageId} /> :
							<Icon name="user" width="16px" color="white" />}
					</div>
					<div>
						<h1>{item.firstName} {item.lastName}</h1>
						<Tag>{item.role}</Tag>
					</div>
				</div>)}
			{!network?.length && tabStatus === TabStatus.Loaded && <p className={styles.emptyContent}><FormattedMessage id="emptyContent.network"/></p>}
		</div>
	);
}

export default NetworkTab;